import { render } from "./AddPaymentLink.vue?vue&type=template&id=6917896d"
import script from "./AddPaymentLink.vue?vue&type=script&lang=js"
export * from "./AddPaymentLink.vue?vue&type=script&lang=js"
script.render = render

export default script